export default __webpack_public_path__ + "static/featureSectionImg-1d7488f4a6b700955fb449e65e3085a6.png";